import React,{useState, useEffect} from 'react';
import { Toast, Image, Navbar, Nav, Container} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFeather, faCircleNotch, faAngleLeft,faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Card from '../card';
import FlipCard from '../flipcard';
import ShuffleCard from '../shufflecard';
import Note from '../note';
import { isMobile, isIOS } from 'react-device-detect';
import { useLanguage } from '../../i18n/LanguageContext';

function Higher(props) {
  const { t } = useLanguage();
  const [currentCards, setCards] = useState(["cover","cover","cover","cover"]);
  const [currentCard, setCard] = useState("0"); //for popup
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showNote, setShowNote] = useState(false);
  const [showSaved, setShowSaved] = useState(true);
  const [saved, setSaved] = useState(props.cards);

  const [shuffle, setShuffle] = useState(["new","new","new","new"]);
  const [update, setUpdate] = useState(0); //for popup

  const [width, setWidth]   = useState(window.outerWidth);
  const [height, setHeight] = useState(window.outerHeight);

  const updateDimensions = () => {
    setWidth(window.outerWidth);
    setHeight(window.outerHeight);
  }

  const rotation = () => {
    if (window.screen && window.screen.orientation){
      const {type, angle} = window.screen.orientation;
      if (type.indexOf("portrait") >= 0){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    else{
      var angle = window.orientation;
      if (angle == 0 || angle == 180){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    
  }

  useEffect(() => {
    
    if (isMobile){
      if (window.screen && window.screen.orientation){
        window.screen.orientation.addEventListener("change", rotation);
      }
      else{
        window.addEventListener("orientationchange", rotation);
      }
    }
    else{
      window.addEventListener("resize", updateDimensions);
    }
    
    return function(){
      if (isMobile){
        if (window.screen && window.screen.orientation){
          window.screen.orientation.removeEventListener("change", rotation);
        }
        else{
          window.removeEventListener("orientationchange", rotation);
        }
      }
      else{
        window.removeEventListener("resize", updateDimensions);
      }
    } 
    
  },[]);

  if (currentCards[0] == "cover"){
    if (props.cards){
      setShuffle(["false","false","false","false"]);
      setCards(props.cards.cards);
      setShowSaved(true);
    }
    else{
      var keys = getRandomKeys(4);
      setCards(keys);
      setShowSaved(false);
    }
  }

  function handleClick(index, flipped){
    if (flipped){
      setCard(currentCards[index]);
      handleShow();
    }
    else{
      setShowSaved(true);
    } 
  }

  function getRandomKeys(count){
    var keys = [];
    for (var i=0;i<count;i++){
      var key = getRandomKey(keys);
      keys.push(key);
    }
    return keys;
  }

  function getKey(){
    var key;
    for (var i=0; i<7; i++){
      key = (Math.floor(Math.random() * 108) + 1).toString();
    }
    return key;
  }

  function getRandomKey(exitingKeys){
    var key = getKey();
    if (exitingKeys.indexOf(key)>=0){
      return getRandomKey(exitingKeys);
    }
    else{
      return key;
    }
  }

  function handleSelect(key){
    if (key=="new"){
        if (update > 0){
        setCards(["cover","cover","cover","cover"]);
        setSaved(null);
        setTimeout(function(){
          setShuffle(["shuffle","shuffle","shuffle","shuffle"]);
        },500)
      }
    }
    else if (key=="back"){
      props.onBackSelected();
    }
    else if (key=="save"){
      //save card to storage with date
      setShowNote(true);
    }
  }

  function handleNoteClose(saved, cards){
    setShowNote(false)
    if (saved){
      setSaved(cards);
    }
  }

  function handleBaseClick(index){
    shuffle[index]="false";
    var count = update + 1;
    setUpdate(count);
  }

  function handleShuffle(index){
    shuffle[index]="new";
    var count = update + 1;
    setUpdate(count);
  }

  function getNote(){
    if (saved){
      return saved.note;
    }
    else{
      return "";
    }
  }

  function getCard(key, shuffle, height, width, card){
    if (shuffle[key] == "new" || shuffle[key] == "shuffle"){
      return (<ShuffleCard key={key} cardno={key + 1} onClick={handleBaseClick.bind(this,key)} onShuffle={handleShuffle.bind(this,key)} height={height} width={width} shuffle={shuffle[key]}></ShuffleCard>)
    }
    else{
      return (<FlipCard key={key} cardno={key + 1} onClick={handleClick.bind(this,key)} card={card} flipped={props.cards != null} height={height} width={width}></FlipCard>)
    }
  }

  function getCards(){
  
    //var cardHeight = 'min(calc(25vw * 1.3), calc(130px * 1.3)';
    //var cardWidth = 'min(calc(25vw), 130px)';
    var h=height;
    var w=width;
    var vmin = Math.min(Math.min(h,1100) - 240, w);

    if (vmin >= h - 340 && (w > h - 340)){
      vmin = h - 340;
    }

    if (vmin < 400){
      if (w > h)
      {
        vmin = 400;
      }
      else{
        vmin = w;
      }
    }

    var cardHeight = (0.25 * vmin * 1.3) + "px";
    var cardWidth = (0.25 * vmin) + "px";

    var spreadWidth = vmin;//width;
    var spreadHeight = spreadWidth;

    var scaleFactor = '0%';
    if (w > 500){
      scaleFactor = '2%';
    }

    
    return (
      
      <div style={{height:spreadHeight,width:spreadWidth, maxHeight:800, maxWidth:800, minHeight:"300px", minWidth:"300px", position:'relative'}}>
      <div style={{position:'absolute', top:'3%', left:'2%', width:"100%", height:"100%"}}><Image src="graphics/higher.png" width="85%" height="100%" style={{opacity:0.9, zIndex:0}}/></div>
      <div style={{position:'absolute',top:'5%', left:'calc(38% + ' + scaleFactor + ')'}}>
      {getCard(0,shuffle,cardHeight, cardWidth, currentCards[0])}</div>
      <div style={{position:'absolute',top:'39%', left:'calc(52% + ' + scaleFactor + ')'}}>
      {getCard(1,shuffle,cardHeight, cardWidth, currentCards[1])}</div>
      <div style={{position:'absolute',top:'72%', left:'calc(37% + ' + scaleFactor + ')'}}>
      {getCard(2,shuffle,cardHeight, cardWidth, currentCards[2])}</div>
      <div style={{position:'absolute',top:'37%', left:'calc(5% + ' + scaleFactor + ')'}}>
      {getCard(3,shuffle,cardHeight, cardWidth, currentCards[3])}</div>
     
     </div>
    )
  };

  function getTitle(){
    if(saved){
      return saved.title
    }
    else{
      return t('spreads.higher.title') + " "  + currentCards.join(',');
    }
  }

  function getScrollHeight(){
    var scrollHeight = "'auto'";
    if (height < 600){
      scrollHeight = 'calc(' + height.toString() + 'px + 280px - env(safe-area-inset-top) - env(safe-area-inset-bottom))';
    }
    return scrollHeight;
  }

  var bgColor = "#fff";
  var fgColor = "#999";
  if (props.theme == "dark"){
    bgColor = "#000";
    fgColor = "#D3D3D3";
  }

  var saveNote = t('common.saveNotes');
  if (saved){
    saveNote = t('common.notes');
  }

  var time = "";
  if (props.cards){
    time = props.cards.time;
  }

  var titlespace = '15px';
  if (height < 800){
     titlespace = '0px';
  }

 
  return (
    <div>
    <Navbar fixed="top" bg={props.theme} variant={props.theme} style={{width: "100%", paddingBottom:0, paddingTop:'calc(env(safe-area-inset-top) + 10px)'}}>
      <Nav fill style={{width: "100%"}} className="justify-content-center" onSelect={handleSelect}>
        <Nav.Link eventKey="back" style={{textAlign: "left", marginLeft:"10px"}}><span aria-hidden="true" class="carousel-control-prev-icon" style={{verticalAlign:'middle'}} onTouchEnd={handleSelect.bind(this, "back")}/></Nav.Link>
        <Nav.Link eventKey="new" hidden={props.cards != null}><span style={{verticalAlign:'middle'}}><FontAwesomeIcon icon={faCircleNotch}  size='1x' /> {t('common.shuffle')}</span></Nav.Link>
        <Nav.Link eventKey="back" hidden={props.cards == null}><span style={{verticalAlign:'middle'}}>{time}</span></Nav.Link>
        <Nav.Link eventKey="save" style={{opacity: (showSaved) ? 1 : 0}}><span style={{verticalAlign:'middle'}}><FontAwesomeIcon icon={faFeather}  size='1x' />{saveNote}</span></Nav.Link>
      </Nav>
  </Navbar>
      <Container fluid style={{overflow:'hidden', paddingTop:'75px',paddingBottom:'85px', 
        height: getScrollHeight()}}>
          <div style={{color:fgColor, paddingTop:titlespace}}><center><b>{t('spreads.higher.title')}</b></center></div>
          <div><center>{getCards()}</center></div>
      </Container>
    <Card card={currentCard} show={show} placement="bottom" name="bottom" onHide={handleClose} ></Card>
    <Note className="saveCardDialog" cards={currentCards} title={getTitle()} saved={saved} type="higher" show={showNote} onHide={handleNoteClose}></Note>
    </div>
  )
};

export default Higher;